import { Contact } from "services/api/contacts/types";
import { FleetDocumentUpload } from "../documents/types";
import { FleetVehicle } from "../types";

/** Odakle dolazi vozač — korisnik aplikacije ili netko iz imenika. */
export enum DriverSourceEnum {
  USER = "USER",
  CONTACT = "CONTACT",
}

export interface FleetVehicleDriver {
  id: string;
  contactId: string | null;
  userId: string | null;
  driversLicenceNumber: string;
  driversLicenceExpiry: Date;
  identityCardNumber: string;
  identityCardExpiry: Date;
  passportNumber: string;
  passportExpiry: Date;
  // Preslike isprava, svaka uz svoju.
  driversLicenceUploads: FleetDocumentUpload[];
  identityCardUploads: FleetDocumentUpload[];
  passportUploads: FleetDocumentUpload[];
}

export interface FleetVehicleDriverRow {
  id: string;
  /** Popunjeno kad je vozač iz imenika. */
  contact: Contact | null;
  /** Popunjeno kad je vozač korisnik aplikacije. */
  userId: string | null;
  /** Ime za prikaz, bez obzira na izvor. */
  name: string | null;
  driversLicenceNumber: string;
  driversLicenceExpiry: Date;
  identityCardNumber: string;
  identityCardExpiry: Date;
  passportNumber: string;
  passportExpiry: Date;
  vehicle: FleetVehicle;
}

export interface FleetVehicleDriverSearchFormValues {
  search: string | null;
  /** Vozilo kojem je vozač zadužen. */
  vehicleId: string | null;
  /** Korisnik aplikacije ili kontakt iz imenika. */
  source: DriverSourceEnum | null;
  /** Rokovi isprava — dovoljno je da jedna isprava upada u raspon. */
  expiryFrom: Date | null;
  expiryTo: Date | null;
}

export interface FleetVehicleDriverEditFormValues {
  id?: string | null;
  /** Vozač je kontakt iz imenika... */
  contactId: string | null;
  /** ...ili korisnik aplikacije. Popunjeno je točno jedno. */
  userId: string | null;
  driversLicenceNumber: string | null;
  driversLicenceExpiry: Date | null;
  identityCardNumber: string | null;
  identityCardExpiry: Date | null;
  passportNumber: string | null;
  passportExpiry: Date | null;
  driversLicenceUploads: FleetDocumentUpload[];
  identityCardUploads: FleetDocumentUpload[];
  passportUploads: FleetDocumentUpload[];
}
